import {
  getRoot,
  IAnyModelType,
  Instance,
  SnapshotIn,
  SnapshotOut,
  types,
} from 'mobx-state-tree';
import { CreditNoteReference } from './CreditNoteStore';
import { Unit } from './products/ProductStore';
import { RootModelType } from './Root';
import { SaleItemReference } from './SaleItemStore';
import { modelWithCRUD } from './utils/modelWithCRUD';
import { VatRateReference } from './VatRateStore';

export const CreditNoteItem = types.model('CreditNoteItem', {
  id: types.union(types.identifier, types.identifierNumber),
  credit_note: types.late(() => CreditNoteReference),
  sale_item: types.late(() => SaleItemReference),
  quantity: types.number,
  unit: types.enumeration<Unit>(Object.values(Unit)),
  creditable_quantity: types.number,
  unit_price: types.number,
  unit_price_currency: types.string,
  vat_rate: types.late(() => VatRateReference),
  sub_total: types.number,
});

export const CreditNoteItemStore = modelWithCRUD(
  'credit-note-items',
  CreditNoteItem
).named('CreditNoteItemStore');

export interface ICreditNoteItem extends Instance<typeof CreditNoteItem> {}
export interface ICreditNoteItemSnapshotIn
  extends SnapshotIn<typeof CreditNoteItem> {}
export interface ICreditNoteItemSnapshotOut
  extends SnapshotOut<typeof CreditNoteItem> {}

export const CreditNoteItemReference = types.reference(
  types.late((): IAnyModelType => CreditNoteItem),
  {
    get(identifier, parent): any {
      return (
        getRoot(parent!) as RootModelType
      ).creditNoteItemStore.getItemNaive(identifier);
    },
    set(value) {
      return value.id;
    },
  }
);
